// DO NOT MODIFY - generated by `rake intl:compile_page[<scope>]` from every page surface's
// config/locales/<scope>/*.yml. Edit those files and re-run instead.
export const LOADERS: Record<string, () => Promise<unknown>> = {

};
// 53d4219c1eae1f7343dafd85556bfec1
